import { type ReactNode } from 'react';
import { AppContainerWrapper, InnerAppContainerWrapper } from './styles';

type AppContainerProps = {
  children: ReactNode;
  header: ReactNode;
  footer: ReactNode;
  backgroundColor?: string;
};
export const AppContainer = ({ header, footer, children }: AppContainerProps) => {
  return (
    <AppContainerWrapper>
      <InnerAppContainerWrapper>
        {header}
        {children}
      </InnerAppContainerWrapper>
      {footer}
    </AppContainerWrapper>
  );
};

export * from './setAppBackgroundColor';
